export enum UserRoles {
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN',
  MANAGER = 'MANAGER',
  TECHNICIAN = 'TECHNICIAN',
}
